// SwiperBase.tsx
import { For, type JSX, createMemo } from "solid-js";

import { useClick } from "@/hooks/useClick.ts";

type SwiperBaseProps<T> = {
  dataList: T[];
  swiperRef?: (el: HTMLDivElement) => void;
  bulletStyle?: () => JSX.Element;
  slideItemStyle: (item: T, index: number) => JSX.Element;
  bulletLocation?: "top" | "bottom";
  class?: string;
  wrapperClass?: string;
  isTop10?: boolean;
  // 走马灯模式动画
  linear?: boolean;
  stopPropagation?: boolean;
};

type SwiperSlideProps = {
  children: JSX.Element;
  class?: string;
  disabledClick?: boolean;
  style?: JSX.CSSProperties;
  item?: unknown;
  isCustomList?: boolean;
  isTop10?: boolean;
};

export const SwiperBase = <T,>(props: SwiperBaseProps<T>) => {
  // 使用createMemo优化数据列表的渲染
  const memoizedDataList = createMemo(() => props.dataList);

  return (
    <div
      class={`swiper ${props.class || ""}`}
      ref={props.swiperRef}
      data-key={Date.now()}
      onClick={(e) => {
        if (props?.stopPropagation) {
          e.stopPropagation();
        }
      }}
    >
      {/*<div class={`swiper ${props.class}`} ref={props.swiperRef}>*/}
      {props.bulletLocation === "top" &&
        props.bulletStyle &&
        props.bulletStyle()}

      <div
        class={`swiper-wrapper ${props?.wrapperClass ? props.wrapperClass : ""} ${props.linear && "swiper-linear"}`}
      >
        <For each={memoizedDataList()} fallback={<></>}>
          {(item, index) => props.slideItemStyle(item, index())}
        </For>
      </div>
      <style>
        {`
         .swiper-linear {
            transition-timing-function: linear !important;
          }
        `}
      </style>

      {props.bulletLocation === "bottom" &&
        props.bulletStyle &&
        props.bulletStyle()}
    </div>
  );
};

export const SwiperSlide = (props: SwiperSlideProps) => {
  const { click } = useClick();

  const handleClick = () => {
    if (!props?.disabledClick && props?.item && props.item?.click_id) {
      click(props.item?.click_id, props.item?.click_params);
    }
  };

  return (
    <div
      class={`swiper-slide ${props?.class ? props.class : ""} ${props?.item && props.item?.click_id ? "cursor-pointer" : ""}`}
      style={props?.style}
      data-key={Date.now()}
      style={props?.style}
      onClick={handleClick}
    >
      {props.children}
    </div>
  );
};
